// src/LoginForm.js
import React, { useState, useEffect, useRef } from 'react';
import { useHistory,useLocation } from 'react-router-dom';
import apiUrl from "../../services/environment"
import Logo from "../../assets/images/logo.svg"
import axiosInstance from "../../services/api";
import { toast } from 'react-toastify';
import Loader from '../Commons/Loader';
// import Cookies from 'js-cookie';
const ChangePasswordBeforeLogin = () => {
    const history = useHistory();
    const location = useLocation();
    const [errors, setErrors] = useState({});
    const hasRedirected = useRef(false);
    const [successMessage, setSuccessMessage] = useState(""); 
    const passwordUpdated = JSON.parse(localStorage.getItem("passwordUpdated"));
    const tfaEnabled = JSON.parse(localStorage.getItem("tfaEnabled"));
    const [errorMessage, setErrorMessage] = useState(""); 
    const [showPassword, setShowPassword] = useState(false);
    const [showNewPassword, setNewShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    //const passwordVerified = localStorage.getItem("passwordVerified");
    if(passwordUpdated){
        history.push('/dashboard');
        console.log("kiop")
    }

    const [formData, setFormData] = useState({
        id:null,
        currentpassword: "",
        newpassword: "",
        confirmnewpassword: "",
    });

    const validate = () => {
        let tempErrors = {};
        let isValid = true;
    
        // Strong password regex pattern
        const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    
        if (!formData.newpassword) {
            tempErrors.newpassword = "Please enter a new password";
            isValid = false;
        } else if (!passwordPattern.test(formData.newpassword)) {
            tempErrors.newpassword = "Password must be at least 8 characters, include uppercase, lowercase, number, and special character";
            isValid = false;
        }
    
        if (!formData.confirmnewpassword) {
            tempErrors.confirmnewpassword = "Please confirm your new password";
            isValid = false;
        } else if (formData.newpassword !== formData.confirmnewpassword) {
            tempErrors.confirmnewpassword = "New password and confirm password do not match";
            isValid = false;
        }
    
        setErrors(tempErrors);
        return isValid;
    };
    
  const handleChange = (e) => {
   
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
    setSuccessMessage(""); // Clear success message on input chang
  };

  const handleSubmit = async (e) => {
    toast.dismiss();
    e.preventDefault();

    if (validate()) {
    setLoading(true);
    try {
        // const { confirmPassword, selectGroup, ...filteredFormData } = formData;
        const payload = {
            oldPassword: formData.currentpassword,
            newPassword: formData.newpassword // Fixed key name here
        };
        const response = await axiosInstance.post('user/change-password', payload);
        if (response.status === 200) {
            if(response.data.status.code===200) {
                toast.success(response.data.status.message);
                //setSuccessMessage(response.data.status.message);
                localStorage.setItem('passwordUpdated', true);
                if(successMessage) {
                    setTimeout(() => {
                           // history.push("/dashboard");
                        //localStorage.setItem('passwordUpdated', true);
                    }, 1000);
                }
                setFormData({ newpassword: "", confirmnewpassword: "", currentpassword:"" });
            }else{
                toast.error(response.data.status.message);
                // setErrorMessage(response.data.status.message)
            }
            
             // Clear form fields
            setTimeout(() => {
                setSuccessMessage("");
                setErrorMessage("");
                //history.push('/dashboard'); 
            }, 2000);
        }
        } catch (error) {
        console.error('Error validating OTP:', error);
        }finally {
            setLoading(false);
          }
    }
  };
  const backToLogin = async () => {
    localStorage.clear();
    setTimeout(() => {
      //history.replace('/login'); // Replace with your navigation logic
      window.location.reload(); 
    }, 100); 
  };
//console.log(apiUrl,"apiUrl")
  return (
    <>
    {loading && <Loader />} 
    <div className='login-wrapper'>
      <div className="login-form change-password-before-login">
          <div className='login-left'>
            <img src={Logo} alt=""/>
          </div>
          <div className='login-right'>
            <h2>Change Password</h2>
            <form className="row" onSubmit={handleSubmit}>
                <div className="col-12">
                    <div className="form-group pos-rel-change-password">
                        <label>Current Password <span>*</span></label>
                        <input type={showPassword ? "text" : "password"} className="input-fld" name="currentpassword" value={formData.currentpassword} onChange={handleChange} />
                        <a className='see-password' onClick={() => setShowPassword((prev) => !prev)}> {showPassword ? <i className="nav-icon fas fa-eye-slash" /> : <i className="nav-icon fas fa-eye" />} </a>
                        {errors.currentpassword && <span className="error">{errors.currentpassword}</span>}
                    </div>
                </div>
                <div className="col-12">
                    <div className="form-group pos-rel-change-password">
                        <label>New Password <span>*</span></label>
                        <sup className="password-type">(Password must be at least 8 characters, include uppercase, lowercase, number, and special character)</sup>
                        <input type={showNewPassword ? "text" : "password"}  className="input-fld" name="newpassword" value={formData.newpassword} onChange={handleChange} />
                        <a className='see-password' onClick={() => setNewShowPassword((prev) => !prev)}> {showNewPassword ? <i className="nav-icon fas fa-eye-slash" /> : <i className="nav-icon fas fa-eye" />} </a>
                        {errors.newpassword && <span className="error">{errors.newpassword}</span>}
                    </div>
                </div>
                <div className="col-12">
                    <div className="form-group">
                        <label>Confirm New Password <span>*</span></label>
                        <input type="password" className="input-fld" name="confirmnewpassword" value={formData.confirmnewpassword} onChange={handleChange} />
                        {errors.confirmnewpassword && <span className="error">{errors.confirmnewpassword}</span>}
                        {/* {successMessage && <p className="suceess-msg" style={{ color: 'green' }}>{successMessage}</p>}
                        {errorMessage && <p className="error-msg" style={{ color: 'red' }}>{errorMessage}</p>} */}
                    </div>
                </div>
                
                <div className="col-12">
                    <button onClick={handleSubmit} className="btn btn-primary submit-btn">Submit</button>
                </div>
            </form>
            <div className=''>
                <a onClick={backToLogin} className='btn-link'>Back To Login</a>
            </div>
          </div>
      </div>
    </div>
    </>
  );
};

export default ChangePasswordBeforeLogin;
